export default {"src":"/_next/static/media/kite_surf.646e7cce.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};